/**
 * CanvasMode - Canvas view embedded in workspace
 * Embeds CanvasExplorer
 */

import type { WorkspaceContext } from '@/stores/workspaceStore'
import { CanvasExplorer } from '@/components/canvas/CanvasExplorer'

interface CanvasModeProps {
  context: WorkspaceContext
}

export function CanvasMode({ context }: CanvasModeProps) {
  return (
    <div className="h-full bg-warm-50">
      <CanvasExplorer hideAuxiliaryPanels={true} />
    </div>
  )
}
